import React from "react";
import "../style/DealsOfTheDay.css";
import boots from '../assets/boots.png';
import bangels from '../assets/bangles.png';
import perfume from '../assets/niveaperfume.png';
import purse from '../assets/pursead.png';

export default function DealsOfTheDay() {
  const deals = [
    {
      store: "Flipkart",
      discount: "77% OFF",
      description: "Premium Handmade Chelsea |Soft Cushioned Insole |Slip-Resistance Boots For Men",
      newPrice: "₹455",
      oldPrice: "₹1,999",
      logo: boots,
      url: "https://www.flipkart.com/big-liner-premium-handmade-chelsea-soft-cushioned-insole-slip-resistance-boots-men/p/itm4d86445918b60?pid=SHOHD3K89HGYAQZ7&lid=LSTSHOHD3K89HGYAQZ7OSSFG9&marketplace=FLIPKART&store=osp%2Fcil%2Fe1f&srno=b_1_4&otracker=browse&fm=organic&iid=6a6f3480-896b-45a7-a589-eb315123d78b.SHOHD3K89HGYAQZ7.SEARCH&ppt=browse&ppn=browse&ov_redirect=true"
    },
    {
      store: "Amazon",
      discount: "91% OFF",
      description: "ZULKA Non-Precious Metal with Base Metal and Zircon Gemstone Studded Premium and Traditional Glossy Finished Sleek Bangle set for Women and Girls",
      newPrice: "₹281",
      oldPrice: "₹3,299",
      logo: bangels,
      url: "https://www.amazon.in/ZULKA-Non-Precious-Gemstone-Finished-Silver_2-6/dp/B0838J1799/ref=pd_rhf_gw_s_pd_crcd_d_sccl_1_2/521-8004341-3156219?pd_rd_w=kFV1u&content-id=amzn1.sym.7edc8fe7-49c8-4837-acf4-779a8e8647e2&pf_rd_p=7edc8fe7-49c8-4837-acf4-779a8e8647e2&pf_rd_r=ZAB541PFHQFPC9SJ7P9S&pd_rd_wg=5xTpG&pd_rd_r=fba8e3db-ab01-4789-8b32-13d4f2b046d2&pd_rd_i=B0838J1799&th=1"
    },
    {
      store: "Myntra",
      discount: "Rs.108 OFF",
      description: "Men Fresh Active Roll-On Deodorant 50 ml",
      newPrice: "141",
      oldPrice: "₹249",
      logo: perfume,
      url: "https://www.myntra.com/roll-ons/nivea/nivea-men-fresh-active-roll-on-deodorant-50-ml/2273997/buy"
    },
    {
      store: "AJIO",
      discount: "50% OFF",
      description: "Women Western Satchel",
      newPrice: "₹5,000",
      oldPrice: "₹9,999",
      logo: purse,
      url: "https://www.ajio.com/anne-klein-women-western-satchel/p/701157510_blue?"
    }
  ];

  return (
    <div className="deals-section">
      <div className="deals-header">
        <h2>Deals Of The Day</h2>
      </div>

      <div className="deals-grid">
        {deals.map((deal, idx) => (
          <div key={idx} className="deal-card">
            {/* Discount Badge */}
            <span className="deal-badge">{deal.discount}</span>

            {/* Store logo */}
            <img src={deal.logo} alt={deal.store} className="deal-logo" />

            {/* Store name */}
            <h3 className="deal-store">{deal.store}</h3>

            {/* Description */}
            <p className="deal-desc">{deal.description}</p>

            {/* Prices */}
            <div className="deal-pricing">
              <span className="deal-price">Rs. {deal.newPrice}</span>
              {deal.oldPrice && (
                <span className="deal-old-price">Rs. {deal.oldPrice}</span>
              )}
            </div>

            {/* CTA button */}
            <a
              href={deal.url}
              target="_blank"
              rel="noopener noreferrer"
              className="deal-btn"
            >
              Get Deal
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
